import { StockMovementCoreResponse } from 'skladon-types';

import { GridOutput, ToCoreGridInput } from '../../grid';
import { StockMovementsMapper } from '../StockMovementsMapper';
import { asInt } from './coerceNumbers';

const coerceCount = <T extends { count?: number | string | null }>(row: T): T => {
    if (row.count === undefined) {
        return row;
    }
    const count = asInt(row.count);
    if (count === null) {
        return row;
    }
    return { ...row, count };
};

export class StockMovementsMapperV21 {
    static fromCore(input: StockMovementCoreResponse) {
        return coerceCount(StockMovementsMapper.fromCore(input));
    }

    static toCoreGrid(input: ToCoreGridInput) {
        return StockMovementsMapper.toCoreGrid(input);
    }

    static fromCoreGrid(input: GridOutput<StockMovementCoreResponse>) {
        const result = StockMovementsMapper.fromCoreGrid(input);

        return {
            ...result,
            data: result.data.map((item) => {
                const row = coerceCount(item as { count?: number | string | null; id?: number | string | null });

                if (!('id' in row) || row.id === undefined) {
                    return row;
                }

                return { ...row, id: asInt(row.id) };
            }),
        };
    }
}
